import * as React from 'react';
import classNames from 'classnames';

import classes from './section.module.scss';

interface Props {
  as?: React.ElementType;
  className?: string;
  children: React.ReactNode;
}

export const Section = ({
  as: Component = 'section',
  className,
  ...props
}: Props) => (
  <Component
    className={classNames(classes.section, className)}
    {...(props as any)}
  />
);
